import { render } from "./ServiceListItem.vue?vue&type=template&id=2b11500a&scoped=true&ts=true"
import script from "./ServiceListItem.vue?vue&type=script&lang=ts"
export * from "./ServiceListItem.vue?vue&type=script&lang=ts"

import "./ServiceListItem.vue?vue&type=style&index=0&id=2b11500a&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b11500a"]])

export default __exports__